module.exports = __webpack_public_path__ + "static/media/usd-square.319ed464.svg";